import * as React from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import Swal from 'sweetalert2'

import DialogTitle from '@mui/material/DialogTitle'
import styled from 'styled-components'
import { useState, useEffect } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import axios from 'axios'
import HeaderName from '../../HeaderName'
import { useSelector } from 'react-redux'

export default function ConvertDialog(props) {
    const token = localStorage.getItem('token')
    const url = process.env.REACT_APP_APP_URL
    const api = axios.create({
        baseURL: url,
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    })

    // console.log(props.itemID, 'props.itemID?')
    const [expDate, setExpDate] = useState("");
    const [fromUnit, setFromUnit] = useState(1);
    const [toUnit, setToUnit] = useState("");
    const [qty, setQty] = useState(0);
    const [totalUnit, setTotalUnit] = useState(0);
    const [relatedUnitID, setRelatedUnitID] = useState("");
    const [relatedUnitConvention, setRelatedUnitConvention] = useState("");
    const [unitConventionLists, setUnitConventionLists] = useState([]);
    const [relatedBrandList, setRelatedBrandList] = useState([])
    const [category, setCategory] = useState('')
    const [subCategory, setSubCategory] = useState('')
    const [categoryLists, setCategoryLists] = useState([])
    const [subCategoryLists, setSubCategoryLists] = useState([])
    const [relatedCat, setRelatedCat] = useState('')
    const [relatedFromUnitName, setRelatedFromUnitName] = useState("");
    const [relatedToUnitName, setRelatedToUnitName] = useState("");
    const [originalPrice, setOriginalPrice] = useState(0);
    const [purchasePrice, setPurchasePrice] = useState("");
    const [sellingPrice, setSellingPrice] = useState("");
    const [reSubCat, setReSubCat] = useState('')

    const [code, setCode] = useState('')
    const [name, setName] = useState('')
    const [relatedBrand, setRelatedBrand] = useState('')

    const [description, setDescription] = useState('')

    const ConvertCreate = () => {
        const data = {
            relatedItem: props.medID?._id,
            relatedItemUnit: relatedToUnitName,
            relatedUnitConvention: relatedUnitConvention,
            relatedFromUnit: relatedFromUnitName,
            relatedToUnit: relatedToUnitName,
            fromUnit: fromUnit,
            toUnit: toUnit,
            totalUnit: totalUnit,
            expiredDate: expDate || props.batchID?.expiredDate,
            qty: qty,
            removeBatchID: props.batchID._id,
            sub_item_id: props.itemID?._id

        }
        if (props.branchID) {
            data.relatedBranch = props.branchID
        } else {

        }

        // alert(JSON.stringify(data))
        const config = {
            headers: { 'Content-Type': 'application/json' }
        }
        api.post('unit-convert', data, config).then(function (response) {
            Swal.fire({
                title: 'Successful!',
                text: 'You Converted Stock!',
                icon: 'success',
                showConfirmButton: false,
                timer: 2000
            })
            window.location.reload()

            // props.setMedicineLists([...props.medicineLists, response.data.data])
        })

            .catch(function (err) {
                Swal.fire({
                    title: 'Something Wrong!',
                    text: 'Error',
                    icon: 'warning',
                    showConfirmButton: false,
                    timer: 2000
                })
            })
        props.setOpenConvert(false)
    }
    const calculateTotal = (qty) => {
        setQty(parseInt(qty))
        if (qty) {
            let multi = qty * toUnit;
            let ans = multi / (fromUnit || 0);

            setTotalUnit(ans.toFixed(2));
        }
    }
    const handleUnitCalculation = (event) => {
        if (qty) {
            let multi = qty * event;
            let ans = multi / (fromUnit || 0);

            setTotalUnit(ans.toFixed(2));
        }

        setToUnit(event);
    };
    const handleToUnit = (id) => {
        console.log(id, "u");
        setRelatedUnitConvention(id);

        const res = unitConventionLists.filter((el) => el._id === id)[0];
        setRelatedToUnitName(res?.relatedToUnit?._id);
        console.log(res, "res");
        setOriginalPrice(res?.relatedFromUnit?.purchasePrice);
        setPurchasePrice(res?.relatedFromUnit?.purchasePrice);
        setSellingPrice(res?.relatedFromUnit?.sellingPrice);
        setFromUnit(res.fromUnit);
        setToUnit(res.toUnit);
        console.log(res.toUnit);
        handleUnitCalculation(res.toUnit);
    };

    useEffect(() => {
        const getCategory = async () => {
            try {
                const res = await api.get('categories')

                setCategoryLists(res.data.data)
            } catch (err) { }
        }
        const getSubCategory = async () => {
            try {
                const res = await api.get('sub-categories')

                setSubCategoryLists(res.data.data)
            } catch (err) { }
        }

        const getBrandLists = async () => {
            try {
                const res = await api.get('brands')
                setRelatedBrandList(res.data.data)
            } catch (err) {
                alert(err.message)
            }
        }
        const getUnitLists = async () => {
            try {
                const res = await api.get("unit-convention");

                // setUnitLists(res.data.list.filter((el)=>el.name._id == medicineListId))
                const filtered = res.data.data.filter(
                    (el) => el.relatedItem?._id === props.medID?._id
                );
                setUnitConventionLists(filtered);
                console.log(filtered, "u");
            } catch (err) { }
        };
        getUnitLists()
        getCategory()
        getSubCategory()

        getBrandLists()
    }, [props.medID])
    // const handleUnitCalculation = (event) => {
    //     if (qty) {
    //         let multi = qty * event;
    //         let ans = multi / (fromUnit || 0);

    //         setTotalUnit(ans.toFixed(2));
    //     }

    //     setToUnit(event);
    // };
    // const handleToUnit = (id) => {
    //     setRelatedUnitConvention(id);
    //     const res = unitConventionLists.filter((el) => el._id === id)[0];
    //     setFromUnit(res.fromUnit);
    //     setToUnit(res.toUnit);
    //     console.log(res.toUnit);
    //     handleUnitCalculation(res.toUnit);
    // };
    const clearData = () => {
        setQty(0)
        setTotalUnit(0)
        setToUnit(0)
        props.close()


    }
    return (
        <div>
            <Dialog open={props.open} onClose={props.close} fullWidth maxWidth='md'>
                <DialogTitle>
                    <div className='modal-header ok'>
                        <h4 className='modal-title'>Convert Stock Unit For {props.medID?.medicineItemName}</h4>
                        <button
                            type='button'
                            className='close'
                            data-dismiss='modal'
                            aria-label='Close'
                            onClick={props.close}
                        >
                            <span aria-hidden='true'>&times;</span>
                        </button>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText></DialogContentText>

                    {/* @csrf */}
                    <div class='modal-body'>

                        <div class='form-group'>
                            <label for='code'>Product Name</label>
                            <input
                                type='text'
                                class='form-control border border-info'
                                name='code'
                                value={props.itemID?.relatedItem?.name?.name}
                            // onChange={e => setQty(e.target.value)}
                            />
                        </div>
                        <div class='form-group'>
                            <label for='code'>Item Name</label>
                            <input
                                type='text'
                                class='form-control border border-info'
                                name='code'
                                value={props.itemID?.relatedItem?.medicineItemName}
                            // onChange={e => setQty(e.target.value)}
                            />
                        </div>
                        {/* <div class='form-group ml-1'>
                            <label for='name'>Unit</label>
                            <select
                                class='custom-select border-info'
                                name='account_type_id'
                                id='cat'
                                onChange={e => setRelatedUnitID(e.target.value)}
                            >
                                <option>Choose Unit</option>
                                {props.medID?.relatedItemUnits?.map(option => (
                                    <option value={option._id}>{option.unitName}</option>
                                ))}
                            </select>
                        </div> */}
                        <div class='form-group'>
                            {/* {console.log(props.itemID, 'ii')} */}
                            <label for='code'>Total InStock {props.itemID?.relatedToUnit?.unitName} Quantity</label>
                            <input
                                type='number'
                                class='form-control border border-info'
                                name='code'
                                value={props.batchID?.currentQuantity * props.itemID?.toUnit}
                            // onChange={e => setQty(e.target.value)}
                            />
                        </div>
                        <div class='form-group'>
                            <label for='code'>Convert Quantity</label>
                            <input
                                type='number'
                                class='form-control border border-info'
                                name='code'
                                placeholder={`Enter ${props.itemID?.relatedToUnit?.unitName || props.itemID?.relatedItemUnit?.unitName} number`}
                                onChange={e => calculateTotal(e.target.value)}
                            />
                        </div>
                        {/* <div class='form-group'>
                            <label
                                for='name'

                            // className={!toUnit && "text-danger"}
                            >
                                Unit Convention (Optional)
                            </label>
                            <select
                                name=''
                                id=''

                                // disabled={qty === '' && true}
                                onChange={(e) => handleToUnit(e.target.value)}
                                className='form-control'
                            >
                                <option hidden>Choose Item</option>
                                {unitConventionLists[0] &&
                                    unitConventionLists.map((u, i) => (
                                        <option value={u._id}>
                                            From-{u.fromUnit} => To-{u.toUnit}
                                        </option>
                                    ))}
                            </select>
                        </div>

                        <div className='row'>
                            <div className='col-md-6'>
                                <label>From Unit</label>
                                <input
                                    type='number'
                                    class='form-control border-info'
                                    name='balance'
                                    id='from'
                                    placeholder='From'
                                    value={1}
                                    disabled
                                    onChange={(e) => setFromUnit(e.target.value || 1)}
                                />
                            </div>
                            <div className='col-md-6'>
                                <label>To Unit</label>
                                <input
                                    type='number'
                                    class='form-control border-info'
                                    name='balance'
                                    id='to'
                                    placeholder='To'
                                    disabled
                                    value={toUnit}
                                // onChange={(e) =>
                                //     handleUnitCalculation(e.target.value)
                                // }
                                />
                            </div>
                        </div>
                        <div class='form-group'>
                            <label for='name' className='text-secondary'>
                                Total Unit
                            </label>
                            <input
                                type='number'
                                class='form-control border-info'
                                name='balance'
                                id='total'
                                disabled
                                //   ref={(el) => (this.name = el)}
                                value={totalUnit}
                            />
                        </div> */}
                        <>
                            <div
                                for='name'
                                className={!toUnit && "text-danger"}
                            >
                                Unit Convention (Optional)
                            </div>
                            <div className='row'>
                                <div class='form-group col-6'>
                                    <label
                                        for='name'
                                    // className={!toUnit && "text-danger"}
                                    >
                                        From Unit Name
                                    </label>

                                    <select
                                        name=''
                                        id=''
                                        onChange={(e) =>
                                            setRelatedFromUnitName(e.target.value)
                                        }
                                        className='form-control'
                                    >
                                        <option hidden>Choose</option>
                                        {unitConventionLists[0] &&
                                            unitConventionLists.map((u, i) => (
                                                <option value={u?.relatedFromUnit?._id}>
                                                    {u?.relatedFromUnit?.unitName ||
                                                        "not set"}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                                <div class='form-group col-6'>
                                    <label for='name'>To Unit Name</label>
                                    <select
                                        name=''
                                        id=''
                                        onChange={(e) => handleToUnit(e.target.value)}
                                        className='form-control'
                                    >
                                        <option hidden>Choose</option>
                                        {unitConventionLists[0] &&
                                            unitConventionLists.map((u, i) => (
                                                <option value={u._id}>
                                                    {u?.relatedToUnit?.unitName ||
                                                        "not set"}
                                                </option>
                                            ))}
                                    </select>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-6'>
                                    <label>From Unit Convert Qty</label>
                                    <input
                                        type='number'
                                        class='form-control border-info'
                                        name='balance'
                                        id='from'
                                        placeholder='From'
                                        value={1}
                                        disabled
                                        onChange={(e) =>
                                            setFromUnit(e.target.value || 1)
                                        }
                                    />
                                </div>
                                <div className='col-md-6'>
                                    <label className={!toUnit && "text-danger"}>
                                        To Unit Equivalent Qty
                                    </label>
                                    <input
                                        type='number'
                                        class='form-control border-info'
                                        name='balance'
                                        id='to'
                                        placeholder='To'
                                        // disabled={type === "Direct"}
                                        value={toUnit || 1}
                                        onChange={(e) =>
                                            handleUnitCalculation(e.target.value)
                                        }
                                    />
                                </div>
                            </div>
                            <div class='form-group'>
                                <label for='name' className='text-secondary'>
                                    Total Unit
                                </label>
                                <input
                                    type='number'
                                    class='form-control border-info'
                                    name='balance'
                                    id='total'
                                    //   ref={(el) => (this.name = el)}
                                    value={totalUnit}
                                />
                            </div>
                        </>
                        <div class='row form-group mt-3'>
                            <label htmlFor=''>Expired Date</label>
                            <input
                                type='date'
                                className='form-control'
                                defaultValue={props.batchID?.expiredDate?.split("T")[0]}
                                onChange={(e) => setExpDate(e.target.value)}
                            />
                        </div>
                        {/* <div class='form-group'>
                            <label for='name'>Description</label>
                            <textarea
                                className='form-control'
                                id='description'
                                onChange={e => setDescription(e.target.value)}
                            ></textarea>
                        </div> */}
                    </div>
                    <div class='modal-footer'>
                        <Button
                            class='btn btn-secondary'
                            data-dismiss='modal'
                            onClick={clearData}
                        >
                            Close
                        </Button>
                        <Button class='btn btn-primary' onClick={ConvertCreate}>
                            Save
                        </Button>
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    )
}

